import { api } from './_request';

export const get = () => {
	return (dispatch) => {

		api().get('/tickets')
		.then(function(response)
		{
			if(response.status === 200)
			{
				dispatch({
					type: 'OLDTICKETS_LIST',
					payload: response.data
				});
			}
		});

	}
}


// WEBPACK FOOTER //
// ./src/actions/oldtickets.js